import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {filter, of, timer} from 'rxjs';
import {catchError, map, mergeMap, switchMap, takeUntil} from 'rxjs/operators';
import * as ProcessInfoActions from './process-info.actions';
import {ProcessInfoService} from './process-info.service';
import * as ResearchPaperActions from '../../research/services/research-paper/research-paper.actions';
import {generateProjectSummaryComplete} from '../../summary/services/summary/summary.actions';

@Injectable()
export class ProcessInfoEffects {

  private readonly service: ProcessInfoService = inject(ProcessInfoService);
  private readonly actions$: Actions = inject(Actions);

  startSseStream$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProcessInfoActions.startProcessInfoSseStream),
      mergeMap(() =>
        this.service.processInfoStreamStream().pipe(
          map((message) => {
            if (message.process === 'CHAT_SOURCES') {
              return ProcessInfoActions.receiveChatSourcesMessage({message});
            }
            return ProcessInfoActions.receiveProcessInfoMessage({message});
          }),
          catchError((error) => of(ProcessInfoActions.processInfoStreamError({error}))),
          takeUntil(this.actions$.pipe(ofType(ProcessInfoActions.sseStreamCompleted))) // Stop Stream on Completion
        )
      )
    )
  );


  restartSseStream$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProcessInfoActions.restartSseStream),
      mergeMap(() => [
        ProcessInfoActions.sseStreamCompleted(),
        ProcessInfoActions.startProcessInfoSseStream()
      ])
    )
  );

  screeningCompleted$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProcessInfoActions.receiveProcessInfoMessage),
      filter(({message}) => message && (message.message === 'Screening for project completed' || message.message.includes("Process stopped"))),
      mergeMap(({message}) => [
        ResearchPaperActions.startPaperScreeningComplete({projectId: message.projectId}),
        ProcessInfoActions.stopSseStreamInfo()
      ])
    )
  );

  summaryProcessCompleted$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProcessInfoActions.receiveProcessInfoMessage),
      filter(({message}) => message && (message.message === 'Refined final summary done' || message.message.includes("Process stopped"))),
      mergeMap(({message}) => [
          ProcessInfoActions.stopSseStreamInfo(),
          generateProjectSummaryComplete({projectId: message.projectId}),
        ]
      )
    )
  );

  monitorConnection$ = createEffect(() =>
    timer(10000, 10000).pipe( // Check every 10 seconds after initial 10s delay
      switchMap(() => {
        if (!this.service.isConnectionActive()) {
          console.log('Connection check: SSE stream not active, restarting');
          return of(ProcessInfoActions.startProcessInfoSseStream());
        }
        return of(ProcessInfoActions.checkConnectionStatus());
      })
    )
  );
}
